import { useEffect } from 'react';

import posthog from 'posthog-js';

import AppProviders from '@/components/providers/AppProviders';
import Devtools from '@/features/devtools/Devtools';
import useRememberComposeFont from '@/features/email/hooks/useRememberComposeFont';

import AppRouter from './router/AppRouter';

export default function App() {
  useRememberComposeFont();

  useEffect(() => {
    posthog.capture('App mounted', {
      appVersion: import.meta.env.VITE_APP_VERSION,
      locale: navigator.language,
    });
  }, []);

  return (
    <AppProviders>
      <Devtools>
        <AppRouter />
      </Devtools>
    </AppProviders>
  );
}
